/* Doubled selector outranks LeafyGreen's runtime-injected Emotion styles.
   Remove when this component migrates to Via. */
.pagination.pagination {
  gap: var(--via-space-600);
  width: fit-content;
}

/* Prevent the inner items from shrinking in a flexbox. */
.pagination.pagination * {
  min-width: fit-content;
}
